import { PropsWithChildren } from 'react';
import './styles.css';

export function Centered(props: PropsWithChildren<object>) {
  return (
    <div className="mi-ui-centered">
      <div>{props.children}</div>
    </div>
  );
}
